import { downloadsService } from "@/api/downloads.service";
import { ref } from "vue";

export class Download{
    public name: string;
    public titel: string;
    public teaser: string;
    public url: string;
    public letter:string;
    public size:string;

    constructor(item:any){
        this.name = item.name ?? "";
        this.titel = item.titel ?? "";
        this.teaser = item.teaser ?? "";
        this.url = item.url ?? "";
        this.letter = item.letter ?? "";
        this.size = item.size ?? "";
    }
}
export class DownloadResults {
    public downloads: Download[];
    public resultCount: number;

    constructor(item:any){
        this.downloads = item.downloads ?? [] as Download[];
        this.resultCount = item.resultCount ?? 0;
    }
}
export function useDownloadOverview(){
    let selectedLetter = ref<string>("");
    let totalCount = ref<number>();
    let displayDownloads = ref<Array<any>>([] as any[]);
    let displayLetters = ref<Array<any>>([] as any[]);
   

    async function initOverview(){
        await getAllDownloadsForLetter("");
        await getLetters();
    }

    async function onSelectLetter(letter:string){
        selectedLetter.value= selectedLetter.value == letter? "": letter;
        await getAllDownloadsForLetter(selectedLetter.value);
    }
    
    async function getLetters(){
        const letters = await downloadsService.getLetters();
        displayLetters.value =   'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map((letter:string) => (
            {   letter: letter,
                hasItems: letters.indexOf(letter)>=0
            }));
    }

    async function getAllDownloadsForLetter(letter:string){
        const results = await downloadsService.getDownloads(letter);
        totalCount.value = results.resultCount;
        displayDownloads.value = results.downloads;
    }

    async function getMoreResults(letter:string){
        const start = displayDownloads.value.length;
        const newDownloads = await downloadsService.getDownloads(letter, start);
        displayDownloads.value = displayDownloads.value.concat(newDownloads.downloads);
        totalCount.value = newDownloads.resultCount;
    }
   

    return {
        selectedLetter,
        totalCount,
        displayDownloads,
        displayLetters,
        onSelectLetter,
        initOverview,
        getMoreResults
    };
};